import { render, staticRenderFns } from "./FileUploadEditor.vue?vue&type=template&id=0dd12e7c"
import script from "./FileUploadEditor.vue?vue&type=script&lang=js"
export * from "./FileUploadEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports